module.exports = __webpack_public_path__ + "static/video1-25f9dd254f1438146159425dff76237a.png";